import fetchHandler from "../../utils/fetchHandler";
import { PROGRESS } from "../types/actions";

export const getProgressCharts = () => {
    const fetchOptions = {
        url: `/api/progress`,
        method: "GET",
        actionType: PROGRESS.GET_PROGRESS_CHARTS
    };
    return fetchHandler(fetchOptions);
};

export const getProgressWeightHistoryList = (queryString) => {
    const fetchOptions = {
        url: `/api/progress/list_weight_history${queryString}`,
        method: "GET",
        actionType: PROGRESS.GET_PROGRESS_WEIGHT_HISTORY_LIST
    };
    return fetchHandler(fetchOptions);
};

export const getProgressMemberWeightHistoryList = (queryString) => {
    const fetchOptions = {
        url: `/api/progress/list_weight_history${queryString}&member_created=True`,
        method: "GET",
        actionType: PROGRESS.GET_PROGRESS_MEMBERWEIGHT_HISTORY_LIST
    };
    return fetchHandler(fetchOptions);
};

export const postAddWeight = (values, successHandler, errorHandler) => {
	const fetchOptions = {
		url: `/api/progress/add_weight`,
		method: "POST",
		actionType: PROGRESS.POST_ADD_WEIGHT,
		body: JSON.stringify(values)
	};
	return fetchHandler(fetchOptions, successHandler, errorHandler);
};
